/* Andria Home — front-end behaviours
   1. Scroll reveal for .ah-reveal elements (safe no-op if none exist)
   2. Launch countdown for [data-ah-countdown] timers
*/
(function () {
  "use strict";

  /* ── Scroll reveal ─────────────────────────────────────── */
  function initReveals() {
    var reveals = document.querySelectorAll(".ah-reveal");
    if (!reveals.length) return;
    if (!("IntersectionObserver" in window)) {
      reveals.forEach(function (el) { el.classList.add("ah-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("ah-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ── Launch countdown ──────────────────────────────────── */
  function pad(n) { return n < 10 ? "0" + n : "" + n; }

  function initCountdowns(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-ah-countdown]").forEach(function (el) {
      if (el._ahTimer) { clearInterval(el._ahTimer); el._ahTimer = null; }

      var raw = (el.getAttribute("data-deadline") || "").trim().replace(" ", "T");
      var deadline = new Date(raw);
      if (isNaN(deadline.getTime())) return;

      var units = {
        days: el.querySelector('[data-unit="days"]'),
        hours: el.querySelector('[data-unit="hours"]'),
        minutes: el.querySelector('[data-unit="minutes"]'),
        seconds: el.querySelector('[data-unit="seconds"]')
      };

      function render() {
        var diff = Math.max(0, deadline.getTime() - Date.now());
        var d = Math.floor(diff / 864e5);
        var h = Math.floor((diff % 864e5) / 36e5);
        var m = Math.floor((diff % 36e5) / 6e4);
        var s = Math.floor((diff % 6e4) / 1e3);
        if (units.days) units.days.textContent = d;
        if (units.hours) units.hours.textContent = pad(h);
        if (units.minutes) units.minutes.textContent = pad(m);
        if (units.seconds) units.seconds.textContent = pad(s);
        if (diff === 0 && el._ahTimer) { clearInterval(el._ahTimer); el._ahTimer = null; }
      }

      render();
      el._ahTimer = setInterval(render, 1000);
    });
  }

  /* ── Help Me Choose quiz ───────────────────────────────── */
  function initQuizzes(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll("[data-ah-quiz]").forEach(function (app) {
      if (app._ahQuizReady) return;
      app._ahQuizReady = true;

      var section = app.closest(".ah-quiz") || app;
      var dataEl = section.querySelector("[data-ah-quiz-data]");
      var collections = [];
      try { collections = JSON.parse(dataEl.textContent).collections || []; } catch (e) {}

      var steps = Array.prototype.slice.call(app.querySelectorAll("[data-quiz-step]"));
      var bar = app.querySelector("[data-quiz-bar]");
      var resultEl = app.querySelector("[data-quiz-result]");
      var backBtn = app.querySelector("[data-quiz-back]");
      var stepsWrap = app.querySelector(".ah-quiz__steps");
      var answers = {};
      var current = 0;

      function show(i) {
        steps.forEach(function (s, idx) { s.classList.toggle("is-active", idx === i); });
        if (bar) bar.style.width = (i / steps.length * 100) + "%";
        if (backBtn) backBtn.hidden = i === 0;
      }

      function score() {
        var best = null, bestScore = -1;
        collections.forEach(function (c) {
          var s = 0;
          // feel
          if (answers.feel === c.feel) s += 3;
          if (answers.feel === "either") s += 1;
          // temperature → crisp/percale runs cooler, sateen cosier
          if (answers.temp === "hot" && c.feel === "crisp") s += 2;
          if (answers.temp === "cool" && c.feel === "soft") s += 2;
          if (answers.temp === "mid") s += 1;
          // colour
          if (answers.colour === c.colour) s += 3;
          if (answers.colour === "ivory" && c.colour === "neutral") s += 1;
          if (answers.colour === "neutral" && c.colour === "ivory") s += 1;
          // style
          if (answers.style === c.style) s += 3;
          if (best === null || s > bestScore) { bestScore = s; best = c; }
        });
        return best || collections[0];
      }

      function finish() {
        var rec = score();
        if (!rec) return;
        if (bar) bar.style.width = "100%";
        var img = app.querySelector("[data-quiz-img]");
        if (img) { img.src = rec.img; img.alt = rec.name + " bedding"; }
        var name = app.querySelector("[data-quiz-name]"); if (name) name.textContent = rec.name;
        var meta = app.querySelector("[data-quiz-meta]"); if (meta) meta.textContent = rec.meta;
        var note = app.querySelector("[data-quiz-note]");
        if (note) {
          var feelWord = rec.feel === "crisp" ? "crisp percale" : "silky sateen";
          note.textContent = "Based on your answers, the " + rec.name + " collection — " + feelWord + " — is your ideal match.";
        }
        if (stepsWrap) stepsWrap.style.display = "none";
        if (backBtn) backBtn.hidden = true;
        if (resultEl) resultEl.hidden = false;
      }

      function next() {
        current++;
        if (current >= steps.length) { finish(); return; }
        show(current);
      }

      app.querySelectorAll(".ah-quiz__opt").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = btn.closest("[data-quiz-step]");
          var q = step.getAttribute("data-q");
          answers[q] = btn.getAttribute("data-val");
          step.querySelectorAll(".ah-quiz__opt").forEach(function (b) { b.classList.remove("is-chosen"); });
          btn.classList.add("is-chosen");
          setTimeout(next, 180);
        });
      });

      if (backBtn) backBtn.addEventListener("click", function () {
        if (current > 0) { current--; show(current); }
      });

      var restart = app.querySelector("[data-quiz-restart]");
      if (restart) restart.addEventListener("click", function () {
        answers = {}; current = 0;
        app.querySelectorAll(".ah-quiz__opt").forEach(function (b) { b.classList.remove("is-chosen"); });
        if (resultEl) resultEl.hidden = true;
        if (stepsWrap) stepsWrap.style.display = "";
        show(0);
      });

      show(0);
    });
  }

  function init() {
    initReveals();
    initCountdowns(document);
    initQuizzes(document);
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);

  /* Re-init when the Shopify theme editor reloads a section */
  document.addEventListener("shopify:section:load", function (e) {
    initCountdowns(e.target);
    initQuizzes(e.target);
  });
})();
